import React from "react";
import { Form, Label } from "semantic-ui-react";

const TextInput = ({
  input,
  width,
  style,
  type,
  placeholder,
  meta: { touched, error },
  disabled
}) => {
  const {...allStyle} = style !== undefined ? style : {};
  return (
    <Form.Field error={touched && !!error}>
      <input
        {...input}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        style={allStyle}
      />
      {touched && error && (
        <Label basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default TextInput;
